<!-- 图片库 -->
<template>
    <div>
        <Modal v-model="switch_modal" :mask-closable="false" width="1200">
            <div class="modal-title">选择文件</div>
            <!-- 当前用户剩余空间 -->
            <div class="modal-txt" @click="getImgInfo()">
                <span class="header-txt">最大可上传50M的文件</span>
                <span>
                    {{ free_space.surplus }} / {{ free_space.total
                    }}<Icon type="md-refresh" size="18" />
                </span>
            </div>
            <!-- 主要内容 -->
            <div class="main-container">
                <!-- 左侧内容 -->
                <div class="left-container">
                    <Button class="add-btn" size="large" @click="goAdd"
                        >添加分组</Button
                    >
                    <!-- 全部 -->
                    <div
                        :class="[{ active: lot_item == -1 }, 'lot']"
                        @click="goActiveLotAll"
                    >
                        <img
                            v-if="lot_item == -1"
                            class="wh20"
                            src="@/assets/pictureLibrary/activate.png"
                        />
                        <img
                            v-else
                            class="wh20"
                            src="@/assets/pictureLibrary/default.png"
                        />
                        <span class="lot-name">全部</span>
                    </div>
                    <!-- v-for -->
                    <div
                        :class="[{ active: lot_item == index }, 'lot']"
                        v-for="(item, index) in lot_array"
                        :key="index"
                        @click="goActiveLot(item.id, index)"
                    >
                        <img
                            v-if="lot_item == index"
                            class="wh20"
                            src="@/assets/pictureLibrary/activate.png"
                        />
                        <img
                            v-else
                            class="wh20"
                            src="@/assets/pictureLibrary/default.png"
                        />
                        <span class="lot-name">{{ item.name }}</span>
                        <img
                            class="lot-icon"
                            src="@/assets/pictureLibrary/edit.png"
                            @click.stop="goEdit(item)"
                        />
                        <img
                            class="lot-icon"
                            src="@/assets/pictureLibrary/delete.png"
                            @click.stop="goDel(item.id)"
                        />
                    </div>
                </div>
                <!-- 右侧内容 -->
                <div class="right-container">
                    <div v-if="img_arr.length == 0" class="none-container">
                        <img
                            class="none-img"
                            src="@/assets/pictureLibrary/none-bg.png"
                        />
                        <span>暂无图片，请先上传图片</span>
                    </div>
                    <div class="img-container">
                        <!-- upload -->
                        <Upload
                            class="mt6"
                            multiple
                            ref="upload"
                            :show-upload-list="false"
                            :format="[
                                'jpg',
                                'jpeg',
                                'png',
                                'gif',
                                'mp4',
                                'avi',
                                'mov',
                            ]"
                            :max-size="51200"
                            :on-exceeded-size="exceededSize"
                            :on-format-error="handleFormatError"
                            :before-upload="beforeUpload"
                            :auto-upload="false"
                            action=""
                        >
                            <div class="upload-container">
                                <div class="upload-icon">
                                    <Icon type="md-add" />
                                </div>
                            </div>
                        </Upload>
                        <!-- v-for图片 -->
                        <div
                            v-for="(item, index) in img_arr"
                            :key="index"
                            @click="goActiveImg(item)"
                            :class="[
                                {
                                    imageactive:
                                        newimgsrc.findIndex(
                                            (it) =>
                                                it.random_number ==
                                                item.random_number
                                        ) != -1,
                                },
                                'offside-box',
                            ]"
                        >
                            <div class="video-container">
                                <video
                                    v-if="getOriginalName(item.original_name)"
                                    class="wh100"
                                    :src="
                                        item.path
                                            ? item.path
                                            : prefix + item.random_number
                                    "
                                ></video>
                                <img
                                    v-else
                                    class="wh100"
                                    :src="
                                        item.path
                                            ? item.path
                                            : prefix + item.random_number
                                    "
                                />
                                <div class="upload-del">
                                    <div @click.stop="goDeleteImg(item)">
                                        <img
                                            src="@/assets/pictureLibrary/del.png"
                                        />
                                    </div>
                                </div>
                            </div>
                            <p class="original-name">
                                {{ item.original_name }}
                            </p>
                        </div>
                        <Page
                            class="page-container"
                            show-total
                            :total="storePrams.total"
                            :current="storePrams.page"
                            :page-size="storePrams.limit"
                            @on-change="changeIndexPage"
                        />
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    v-if="newimgsrc.length > 0"
                    class="modal-btn"
                    @click="submitModal"
                    >确认</Button
                >
            </div>
            <div slot="close" @click="cancelModal">
                <i class="ivu-icon ivu-icon-ios-close"></i>
            </div>
        </Modal>
        <!-- 新增/编辑 -->
        <Modal v-model="editModal" :z-index="3000">
            <p slot="header">
                <span class="modal-title">{{ modal_title }}</span>
            </p>
            <div class="modal-container">
                <span class="left-span">分组名称：</span>
                <Input
                    class="left-input"
                    v-model="form_data.name"
                    show-word-limit
                    maxlength="8"
                    placeholder="请输入分组名称"
                />
            </div>
            <div slot="footer">
                <Button @click="editModal = false">取消</Button>
                <Button class="modal-btn" @click="goCreateFolder">保存</Button>
            </div>
        </Modal>
        <!-- 删除 -->
        <Modal v-model="delModal" :z-index="3000">
            <p slot="header">
                <span class="modal-title">{{ modal_title }}</span>
            </p>
            <div class="modal-container">
                <span class="del-span">是否确认删除分组！</span>
            </div>
            <div slot="footer">
                <Button @click="delModal = false">取消</Button>
                <Button class="modal-btn" @click="goDelFolder">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    libray_create_folder,
    libray_show_folder,
    libray_del_folder,
    libray_show_img_list,
    libray_img_info,
    libray_delete_img,
} from "@/api/oss";
import config from "@/config";
import { getCookies } from "@/utils/helper";
export default {
    // 控制大MODAL开关
    props: {
        switch_modal: {
            type: Boolean,
            default: false,
        },
        select: {
            type: Number,
            default: 0,
        },
        select_type: {
            type: String,
            default: "image",
        },
    },
    data() {
        return {
            pushed: false,
            upload_data: { folder_id: "0" }, // 图片上传参数
            prefix: "", // 图片地址前缀
            free_space: {}, // 剩余空间
            lot_item: -1, // 分组列表激活参数
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            uploads: config.apiUrl + "/api/libray/uploads",
            form_data: {
                id: "",
                name: "",
            },
            modal_title: "",
            editModal: false,
            delModal: false,
            lot_array: [], // 显示目录
            img_arr: [], // 显示图片列表
            storePrams: {
                page: 1,
                limit: 20,
                folder_id: 0,
            },
            imagesrc: "", // 选中图片路径
            newimgsrc: [],
            waitUploads: [],
            isUploading: false,
        };
    },
    mounted() {
        // 获取当前用户剩余空间
        this.getImgInfo();
    },
    methods: {
        getOriginalName(str) {
            const lastIndex = str.lastIndexOf(".");
            let text = "";
            if (lastIndex !== -1 && lastIndex < str.length - 1) {
                text = str.substring(lastIndex + 1);
            } else {
                text = "";
            }
            if (text == "mp4" || text == "avi" || text == "mov") {
                return true;
            } else {
                return false;
            }
        },
        // 获取当前用户剩余空间
        getImgInfo() {
            libray_img_info()
                .then((res) => {
                    this.free_space = res.data;
                    this.prefix = res.data.domain;
                    // 显示目录
                    this.getShowFolder();
                    // 显示图片列表
                    this.getShowImgList();
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 显示图片列表
        getShowImgList() {
            libray_show_img_list(this.storePrams)
                .then((res) => {
                    this.img_arr = res.data.data;
                    this.storePrams.total = res.data.total;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        changeIndexPage(e) {
            this.storePrams.page = e;
            this.getShowImgList();
        },
        // 删除图片
        goDeleteImg(item) {
            libray_delete_img({ random: item.random_number })
                .then((res) => {
                    this.getImgInfo();
                    this.getShowImgList();
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        beforeUpload(file) {
            const newFile = new File([file], file.name, { type: file.type });
            this.waitUploads.push(newFile);
            this.startUploadQueue();
            return false;
        },
        async startUploadQueue() {
            if (this.isUploading) return;
            this.isUploading = true;
            this.$Message.loading({ content: "上传中...", duration: 0 });
            while (this.waitUploads.length > 0) {
                const file = this.waitUploads.shift();
                await this.uploadSingleFile(file);
            }
            this.$Message.destroy();
            this.$Message.success("上传成功");
            this.getImgInfo();
            this.getShowImgList();
            this.isUploading = false;
        },
        uploadSingleFile(file) {
            return new Promise((resolve) => {
                const formData = new FormData();
                formData.append("file", file);
                if (this.upload_data) {
                    Object.keys(this.upload_data).forEach((k) => {
                        formData.append(k, this.upload_data[k]);
                    });
                }
                const xhr = new XMLHttpRequest();
                xhr.open("POST", this.uploads);
                if (this.headers) {
                    Object.keys(this.headers).forEach((k) => {
                        xhr.setRequestHeader(k, this.headers[k]);
                    });
                }
                xhr.onload = () => resolve();
                xhr.send(formData);
            });
        },
        handleFormatError() {
            this.$Message.warning("暂不支持上传此格式");
        },
        exceededSize() {
            this.$Message.warning("文件大小限制在50MB以内");
        },
        // 显示目录
        getShowFolder() {
            libray_show_folder()
                .then((res) => {
                    this.lot_array = res.data;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 激活分组列表
        goActiveLot(id, index) {
            this.lot_item = index;
            this.upload_data.folder_id = id;
            // 显示图片列表
            this.storePrams.page = 1;
            this.storePrams.folder_id = id;
            this.getShowImgList();
        },
        // 激活分组列表 -- '全部'
        goActiveLotAll() {
            this.lot_item = -1;
            this.upload_data.folder_id = 0;
            // 显示图片列表
            this.storePrams.page = 1;
            this.storePrams.folder_id = 0;
            this.getShowImgList();
        },
        // 激活图片列表
        goActiveImg(e) {
            let num = this.newimgsrc.findIndex(
                (item) => item.random_number == e.random_number
            );
            if (num == -1) {
                //选中
                if (
                    this.select_type == "video" &&
                    !this.getOriginalName(e.original_name)
                ) {
                    this.$Message.error("请选择视频");
                    return;
                }
                if (
                    this.select_type == "image" &&
                    this.getOriginalName(e.original_name)
                ) {
                    this.$Message.error("请选择图片");
                    return;
                }
                if (this.select == 0) {
                    // 在select值为0时可以一直push
                    this.newimgsrc.push(e);
                } else {
                    if (!this.pushed) {
                        // 只在select值为1时执行一次push操作
                        this.newimgsrc.push(e);
                        if (this.newimgsrc.length == 2) {
                            this.newimgsrc.splice(0, 1);
                        }
                    }
                }
            } else {
                //删除
                this.newimgsrc.splice(num, 1);
                this.pushed = false;
            }
        },
        // 新增name
        goAdd() {
            this.modal_title = "添加分组";
            this.form_data.id = "";
            this.form_data.name = "";
            this.editModal = true;
        },
        // 编辑name
        goEdit(e) {
            this.modal_title = "分组管理";
            this.form_data.id = e.id;
            this.form_data.name = e.name;
            this.editModal = true;
        },
        // 删除name
        goDel(id) {
            this.modal_title = "删除分组";
            this.form_data.id = id;
            this.delModal = true;
        },
        // 新增/编辑弹框保存按钮
        goCreateFolder() {
            libray_create_folder(this.form_data)
                .then((res) => {
                    this.getShowFolder();
                    this.editModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 删除弹框保存按钮
        goDelFolder() {
            libray_del_folder({ id: this.form_data.id })
                .then((res) => {
                    this.getShowFolder();
                    this.delModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 取消按钮
        cancelModal() {
            this.$emit("update:switch_modal", false);
        },
        // 确认按钮
        submitModal() {
            this.$emit("update:switch_modal", false);
            var byValue = [];
            var byValueSrc = [];
            this.newimgsrc.forEach((item) => {
                byValue.push(this.prefix + item.random_number);
                byValueSrc.push(item.random_number);
            });
            // 向父组件传递了1个值
            if (this.newimgsrc.length >= 0) {
                this.$emit("change", byValue, byValueSrc);
            }
        },
    },
};
</script>

<style scoped>
/* 图片列表激活样式 */
.imageactive {
    background-color: #f8e3d5;
    border: 1px solid #ff761d;
    border-radius: 5px;
}
/* 滚动条 */
.left-container::-webkit-scrollbar {
    width: 5px;
}
/*滚动条里面小方块*/
.left-container::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.15);
    background: rgba(144, 147, 153, 0.3);
}
/*滚动条里面轨道*/
.left-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.15);
}
.modal-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #484e66;
}
.modal-txt {
    position: absolute;
    right: 50px;
    cursor: pointer;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
}
.header-txt {
    margin-right: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #666666;
}
.main-container {
    margin-top: 30px;
    height: 550px;
    display: flex;
}
.left-container {
    width: 250px;
    height: 550px;
    background: #ffffff;
    border: 1px solid #999999;
    overflow: auto;
}
/* 左侧添加分组按钮 */
.add-btn {
    margin: 20px;
    background: #ff761d;
    border-color: #ff761d;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
}
/* 左侧列表lot */
.wh20 {
    width: 20px;
    height: 20px;
}
.lot {
    padding: 24px 0 24px 24px;
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
}
.lot:hover {
    background-color: #f8e3d5;
}
.lot-name {
    width: 200px;
    margin-left: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
}
.lot-icon {
    width: 26px;
    height: 26px;
    margin-right: 12px;
}
/* 分组列表激活样式 */
.active {
    background-color: #f8e3d5;
}
.active span {
    color: #ff761d;
}
.right-container {
    width: 900px;
    height: 550px;
    background: #ffffff;
    border: 1px solid #999999;
    border-left: 0;
    position: relative;
}
.img-container {
    margin: 12px;
    width: 850px;
    display: flex;
    flex-wrap: wrap;
}
.upload-container {
    margin: 12px;
    width: 100px;
    height: 100px;
    background: #ecf0f3;
    border: 1px solid #dadada;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.upload-container:hover {
    border: 1px solid #ff761d;
}
.upload-container:active {
    border: 1px solid #ff761d;
}
.upload-container:hover .upload-icon {
    color: #ff761d;
}
.upload-container:active .upload-icon {
    color: #ff761d;
}
.upload-icon {
    font-size: 44px;
    color: #c0c4cc;
}
.offside-box {
    margin: 12px 5px;
    padding: 5px;
    width: 110px;
    height: 130px;
    text-align: center;
    position: relative;
    cursor: pointer;
}
.offside-box:hover {
    box-shadow: 3px 3px 3px 3px rgba(0, 0, 0, 0.05);
}
.upload-del {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.offside-box:hover .upload-del {
    display: block;
}
.none-container {
    position: absolute;
    top: 150px;
    left: 250px;
    width: 400px;
    height: 250px;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #7c8499;
}
.none-img {
    width: 400px;
    height: 200px;
    object-fit: contain;
}
.upload-del div img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    margin-top: -15px;
    margin-right: -15px;
}
.left-span {
    width: 100px;
    font-size: 16px;
}
.left-input {
    width: 100%;
}
.del-span {
    font-size: 16px;
}
.wh100 {
    width: 100%;
    height: 100%;
}
.mt6 {
    margin-top: 6px;
}
.video-container {
    width: 100px;
    height: 100px;
    position: relative;
}
.modal-container {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-btn {
    background: #ff761d;
    color: #ffffff;
    border-color: #ff761d;
}
.page-container {
    margin-top: 24px;
    width: 100%;
    text-align: right;
}
.original-name {
    width: 100px;
    user-select: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
::v-deep .ivu-modal-body {
    max-height: 700px;
}
::v-deep .ivu-modal-mask {
    z-index: 2222 !important;
}
::v-deep .ivu-modal-wrap {
    z-index: 2222 !important;
}
</style>